import { useState } from 'react';
import { type CSVContact } from '../../../Data/DataSource/contacts-nest/contacts/entities/contact.entity';
import { LoadingState } from 'tendril-v1/src/types/LoadingStates.type';
import { type Filters } from 'tendril-v2/src/Domain/interfaces/Contacts/filter.interfaces';
import getContactsByCallSessionIds from 'tendril-v2/src/Data/DataSource/contacts-nest/contacts/getContactsByCallSessionId.ts';

const { IDLE, LOADING, ERROR, SUCCESS } = LoadingState;

export interface useContactsViewModelI {
  viewModelContacts: CSVContact[];
  sessionIds: string[] | undefined;
  setSessionIds: (sessionIds: string[]) => void;
  fetchContactsBySdrId: (callSessionId: string[], filters?: Filters) => Promise<CSVContact[] | undefined>;
  loadingState: useContactsViewModelLoadingState;
}

interface useContactsViewModelLoadingState {
  fetchContactsBySdrId: LoadingState;
}

const useContactsViewModel = (): useContactsViewModelI => {
  const [viewModelContacts, setContacts] = useState<CSVContact[]>([]);
  const [sessionIds, setSessionIds] = useState<string[] | undefined>(undefined);
  const [loadingState, setLoadingState] = useState<useContactsViewModelLoadingState>({
    fetchContactsBySdrId: IDLE,
  });
  const [filtersState, setFiltersState] = useState<Filters>({
    flagged: false,
    no_answer: false,
    voicemail: false,
    transfer_error: false,
    cut_off: false,
  });

  const fetchContactsBySdrId = async (
    callSessionIds: string[],
    filters: Filters | undefined = undefined,
  ): Promise<CSVContact[] | undefined> => {
    setLoadingState((prevState) => ({
      ...prevState,
      fetchContactsBySdrId: LOADING,
    }));

    const { data } = await getContactsByCallSessionIds(callSessionIds, filters ?? filtersState);

    if (data === undefined) {
      setLoadingState({ ...loadingState, fetchContactsBySdrId: ERROR });
      return;
    }

    setContacts(data);

    setLoadingState((prevState) => ({
      ...prevState,
      fetchContactsBySdrId: SUCCESS,
    }));

    filters !== undefined && setFiltersState(filters);

    return data;
  };

  return { viewModelContacts, sessionIds, setSessionIds, fetchContactsBySdrId, loadingState };
};

export default useContactsViewModel;
